<template>
<span>
  <!--<template v-if="sessionUtil.isWxOpenData(openid)">
    <ww-open-data :type="type" :openid="openid" />
  </template>
  <template v-else>
    {{ openid}}
  </template>-->
  {{ openid}}
</span>
</template>

<script>
import {mixin} from './index.js'
export default {
  name: 'wx-show-data',
  mixins: [mixin]
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/common/wx-show-data/index.vue